import { memo, useCallback, useState } from 'react'

import { Box, Divider } from '@mui/material'
import { AnimatePresence } from 'motion/react'
import SimpleBar from 'simplebar-react'

import { DialogTitle } from '@shared/components/MaterialUIEnhancements'
import { useCloseHandler } from '@shared/components/MaterialUIEnhancements/Dialog'
import { Sidebar } from 'domains/_Navigation/Settings'
import { Profile, Design, Language, Network } from 'domains/_Navigation/Settings/Content'
import { Overview as Developer } from 'domains/_Navigation/Settings/Content/Developer'

export type SidebarOptions = 'profile' | 'design' | 'language' | 'network' | 'developer'

const PanelRaw = () => {
  const handleClose = useCloseHandler()

  const [selectedListItem, setselectedListItem] = useState<SidebarOptions>('profile')

  return (
    <>
      <DialogTitle onClose={handleClose}>Personal Settings</DialogTitle>
      <Divider />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
        }}
      >
        <Sidebar
          currentSelection={selectedListItem}
          selectListItem={useCallback((item) => setselectedListItem(item), [])}
        />
        <Box sx={{ pb: 2, pr: 4, pt: 3.5, height: 480, overflowY: 'auto' }} component={SimpleBar}>
          <AnimatePresence mode="wait">
            {selectedListItem === 'profile' && <Profile key="profile" />}
            {selectedListItem === 'design' && <Design key="design" />}
            {selectedListItem === 'language' && <Language key="language" />}
            {selectedListItem === 'network' && <Network key="network" />}
            {selectedListItem === 'developer' && <Developer key="developer" />}
          </AnimatePresence>
        </Box>
      </Box>
    </>
  )
}

export const Panel = memo(PanelRaw)
